export default "<p>user-details-view works!</p>\n"